"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_1 = require("./base");
var SuggestionList = /** @class */ (function (_super) {
    __extends(SuggestionList, _super);
    function SuggestionList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.maxSuggestions = 1;
        _this.query = "";
        return _this;
    }
    SuggestionList.prototype.setQuery = function (query) {
        return this.query = query;
    };
    SuggestionList.prototype.setData = function (response) {
        // Set and return the page items
        //
        return this.data = response.Suggestions;
    };
    SuggestionList.prototype.fetch = function () {
        // Build the request data
        //
        var requestData = {
            Text: this.query || "",
            MaxSuggestions: this.maxSuggestions || 1,
            __response: undefined
        };
        return _super.prototype.fetch.call(this, "GetProductSearchSuggestions", requestData);
    };
    return SuggestionList;
}(base_1.FetchablePagedList));
exports.SuggestionList = SuggestionList;
